var map = {
	"./arrow-left.svg": "9ba7",
	"./arrow-right.svg": "966d",
	"./bar-chart-2.svg": "9ef4",
	"./bell.svg": "a4f9",
	"./calendar.svg": "557c",
	"./check-square.svg": "31dc",
	"./check.svg": "5236",
	"./database.svg": "af95",
	"./download.svg": "24a4",
	"./edit-3.svg": "eb99",
	"./eye.svg": "45c2",
	"./file-text.svg": "cbb2",
	"./file.svg": "890d",
	"./loader.svg": "e063",
	"./maximize-2.svg": "1f30",
	"./pie-chart.svg": "35a9",
	"./report.svg": "2237",
	"./search.svg": "0930",
	"./square.svg": "cc73",
	"./user.svg": "7393",
	"./x.svg": "4ab2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";